import React, { useEffect } from 'react';

import { ErrorBoundary } from 'react-error-boundary';

declare global {
	interface Window {
		__aifcDebuggerStart__: VoidFunction | undefined;
		__aifcDebuggerStop__: VoidFunction | undefined;
		__aifcDebuggerEnabled__: boolean | undefined;
	}
}

const enableDebugging = () => {
	if (window.top) {
		window.top.__aifcDebuggerEnabled__ = true;
	}
};

const disableDebugging = () => {
	if (window.top) {
		window.top.__aifcDebuggerEnabled__ = false;
	}
};

function addAifcDebugListeners() {
	if (window.top) {
		window.top.__aifcDebuggerStart__ = enableDebugging;
		window.top.__aifcDebuggerStop__ = disableDebugging;
	}
}

function removeAifcDebugListeners() {
	if (window.top) {
		window.top.__aifcDebuggerStart__ = undefined;
		window.top.__aifcDebuggerStop__ = undefined;
	}
}

const AifcDebuggerListeners = () => {
	useEffect(() => {
		addAifcDebugListeners();
		return () => {
			removeAifcDebugListeners();
		};
	}, []);

	return null;
};

const onAifcDebuggerError = (error: Error, errorInfo: React.ErrorInfo): void => {
	// eslint-disable-next-line no-console
	console.error('AifcDebugger failed:', error, errorInfo);
};

export const AifcDebugger = (): React.JSX.Element => {
	return (
		<ErrorBoundary fallbackRender={() => null} onError={onAifcDebuggerError}>
			<AifcDebuggerListeners />
		</ErrorBoundary>
	);
};
